/* eslint react/jsx-key: off */
import PeopleIcon from '@material-ui/icons/People';
import memoize from 'lodash/memoize';
import Aside from './Aside';

import React from 'react';
import {
    Datagrid,
    Filter,
    List,
    Responsive,
    SearchInput,
    SimpleList,
    TextField,
    TextInput,
    EditButton,
} from 'react-admin';
export const UserIcon = PeopleIcon;


const UserFilter = ({ permissions, ...props }) => (
    <Filter {...props}>
        <SearchInput source="q" alwaysOn />
        <TextInput source="username" />
        {permissions === 'admin' ? <TextInput source="role" /> : null}
    </Filter>
);

const rowClick = memoize(permissions => (id, basePath, record) => {
    return permissions === 'WM'
        ? Promise.resolve('edit')
        : Promise.resolve('show');
});

const UserList = ({ permissions, ...props }) => (
    <List
        {...props}
        filters={<UserFilter permissions={permissions} />}
        sort={{ field: 'id', order: 'ASC' }}
        aside={<Aside />}
    >
        <Responsive
            small={
                <SimpleList
                    primaryText={record => record.username}
                    secondaryText={record =>
                        permissions === 'admin' ? record.role : null
                    }
                />
            }
            medium={
                <Datagrid
                    rowClick={rowClick(permissions)}
                >
                    <TextField source="username" />
                    <TextField source="email" />
                    <EditButton />
                </Datagrid>
            }
        />
    </List>
);

export default UserList;
